import { COMPANY_GROUP_NAME } from './constants';
import { ExtraWithGroups } from './groups-patch-plugin';
import { prefixCompanyId } from './id-prefix';

export function optionsWithCompanyGroupExtra(companyId: number): ExtraWithGroups {
  return {
    extra: { groups: { [COMPANY_GROUP_NAME]: prefixCompanyId(companyId) } }
  };
}
